<template>
    <span>
        <az-call-to-action dark
                           :active="true"
                           :outline="true"
                           @click="abrirModalMaisBrasil">
            Transferegov.br
        </az-call-to-action>
        <az-confirm @onConfirm="enviarMaisBrasil" @onDecline="esconderDialog"
                    v-if="mostrarDialog" :maxWidth=320>
            Deseja realmente enviar o processo com a seguinte situação?
            <br>
            <input type="radio" v-model="situacao" value="EM_ANDAMENTO">Em andamento
            <br>
            <input type="radio" v-model="situacao" value="CONCLUIDO">Concluído
        </az-confirm>


        <div class="text-xs-center">
            <v-dialog
                    v-model="mostrarModalErro"
                    width="500">
                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        Erro ao enviar
                    </v-card-title>

                    <v-card-text>
                        {{ erroMaisBrasil }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="mostrarModalErro = false"
                        >
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </span>
</template>

<script>
    import {mapMutations, mapState} from 'vuex'
    import {actionTypes, mutationTypes} from '@/commons/constants'
    import store from '../../../../../commons/store'

    export default {
        name: 'LicitacaoAtualizacaoEnviarMaisBrasil',
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarDialog: false,
                situacao: 'EM_ANDAMENTO',
                erroMaisBrasil: '',
                mostrarModalErro: false
            }
        },
        computed: {
            ...mapState(['licitacao', 'loki'])
        },
        methods: {
            abrirModalMaisBrasil() {
                this.mostrarDialog = true
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async enviarMaisBrasil() {
                this.esconderDialog()
                this.habilitarLoading()
                try {
                    const payload = {situacao: this.situacao}
                    this.setMensagemLoading('Enviando...')
                    await store.dispatch(actionTypes.ENVIAR_MAIS_BRASIL, {licitacaoId : this.licitacao.id, payload})
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (e) {
                    if (e.response.data.exception) {
                        this.mostrarModalErro = true
                        this.erroMaisBrasil = e.response.data.message
                        this.erroMaisBrasil = this.erroMaisBrasil.replace("Request processing failed; " +
                            "nested exception is br.com.azi.licitacao.integracao.maisbrasil.exception.MaisBrasilException: ", "")
                    }
                    this.desabilitarLoadingGlobal()
                }
            },
            esconderDialog() {
                this.mostrarDialog = false
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            ...mapMutations([
                mutationTypes.MOSTRAR_MENSAGEM_ERRO
            ])
        }
    }
</script>